import Input2 from './Input2';
export default Input2;
